import * as constants from 'Redux/constants';

import { reducePatch } from '../../helpers/tools';

// actions

export const loadInfomaterialStatus = () => ({
    type: constants.GET_INFOMATERIAL_STATUS,
});

// reducer

export default function infomaterialStatusReducer(
    state = {
        items: [],
        loading: false,
        error: false,
        loadError: false,
    },
    action
) {
    switch (action.type) {
        case constants.GET_INFOMATERIAL_STATUS:
            return {
                ...state,
                loading: true,
                error: false,
                loadError: false,
            };

        case constants.GET_INFOMATERIAL_STATUS_SUCCESS:
            return {
                ...state,
                loading: false,
                error: false,
                loadError: false,
                items: action.data,
            };

        case constants.GET_INFOMATERIAL_STATUS_ERROR:
            return {
                ...state,
                loading: false,
                error: true,
                loadError: action.err,
            };

        case constants.PATCH_CUSTOMER_SUCCESS:
            return reducePatch(
                {
                    ...state,
                    loading: false,
                    error: false,
                    saveSuccess: false,
                },
                action
            );

        default:
            return state;
    }
}
